import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/(frontend)/[page_slug]/page.jsx");
